module.exports = __webpack_public_path__ + "assets/icon-retainer-task-green.31875074.svg";